const STORAGE_KEY = 'blms-query-devtools-enabled';
const QUERY_DEVTOOLS_EVENT = 'blms:query-devtools-preference-changed';

function parseStoredValue(value: string | null): boolean {
  return value === 'true';
}

export function isQueryDevtoolsEnabled(): boolean {
  try {
    return parseStoredValue(localStorage.getItem(STORAGE_KEY));
  } catch {
    return false;
  }
}

export function setQueryDevtoolsEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(enabled));
  } catch {
    // localStorage can be unavailable in privacy mode
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(QUERY_DEVTOOLS_EVENT));
  }
}

export function subscribeToQueryDevtoolsPreference(callback: () => void): () => void {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const handler = () => callback();

  window.addEventListener('storage', handler);
  window.addEventListener(QUERY_DEVTOOLS_EVENT, handler);

  return () => {
    window.removeEventListener('storage', handler);
    window.removeEventListener(QUERY_DEVTOOLS_EVENT, handler);
  };
}
